import React, {Component} from 'react';
import AdminHomeTableRowSubscribe from './admin-home-table-row-subscribe';

class AdminHomeTableSubscribers extends Component{

    

    render(){

        return(
           <div className="tab-pane fade" id="subscribers" role="tabpanel">
                 <div className="text-center">
                    <a className="export-all-btn red-btn" href="/adminhome">إرسال</a>
                </div>
               <div className="studies-tables-admin">
                    <h2 className="studies-title">قائمة المشتركين في النشرة الإخبارية </h2>
                        <table className="table studies-table-admin table-responsive-md">
                                <thead>
                                    <tr>
                                        <th>رقم الجوال </th>
                                        <th>البريد الالكتروني</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <AdminHomeTableRowSubscribe  userPhoneNo={"01120303508"}  userMail={"bana@creteagency.com"}  />
                                    <AdminHomeTableRowSubscribe  userPhoneNo={"01120303508"}  userMail={"bana@creteagency.com"}  />
                                    <AdminHomeTableRowSubscribe  userPhoneNo={"01120303508"}  userMail={"bana@creteagency.com"}  />
                                    <AdminHomeTableRowSubscribe  userPhoneNo={"01120303508"}  userMail={"bana@creteagency.com"}  />
                                    <AdminHomeTableRowSubscribe  userPhoneNo={"01120303508"}  userMail={"bana@creteagency.com"}  />
                                </tbody>
                            </table>
                 </div>
            </div>
                        
            
        );
       
    }

};
export default AdminHomeTableSubscribers;


